import { useTranslation } from 'next-i18next'
import React from 'react'

// Icons
import PauseIcon from '../icons/pauseIconBlack.inline.svg'
import PlayIcon from '../icons/videoPlayIcon.inline.svg'

// Styles
import * as styles from './limitedControlButtons.module.scss'
interface LimitedControlsButtonProps {
  isPlaying: boolean
  onClick: () => void
}
const LimitedControlButtons = ({ isPlaying, onClick }: LimitedControlsButtonProps) => {
  const { t } = useTranslation('common')

  return (
    <button
      className={styles.limitedControlsPlayButton}
      onClick={onClick}
      aria-label={isPlaying ? t('pause_video') : t('play_video')}
    >
      {isPlaying ? (
        <div className={styles.pause}>
          <PauseIcon />
        </div>
      ) : (
        <div className={styles.play}>
          <PlayIcon />
        </div>
      )}
    </button>
  )
}
export default LimitedControlButtons
